import React, { useEffect, useState } from 'react';
const headlines = ['Wie führe ich erfolgreich und authentisch?', 'Wie wirke ich auf andere und wie kann ich meine Wirksamkeit steigern?', 'Wie treffe ich in Zeiten der Unsicherheit fundierte Entscheidungen?', 'Wie führe ich mein Team durch die Veränderung?', 'Neu in der Organisation oder Rolle? Wie gestalten Sie die ersten 100 Tage?'];
export const FuehrungsCoachingPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-321">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-322">
          <div data-id="element-323">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-324">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-325">
            <img src="https://cdn.magicpatterns.com/uploads/1fb9nxx5Q3qZ1RovRUn3p7/Eva-Schifferer-Coaching-Fuehrung.png" alt="Führungs Coaching" className="max-h-80 object-contain" data-id="element-326" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-327">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-328">
          <div data-id="element-329">
            <p className="mb-6 text-base leading-relaxed" data-id="element-330">
              Anlässe, den eigenen Führungsstil auf den Prüfstand zu stellen
              sind vielfältig.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-331">
              Führungs Coaching ist ehrliches Feedback auf Augenhöhe – intensiv
              und wertschätzend.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-332">
              Sie erhalten Unterstützung darin, sich weiter zu entwickeln und
              gleichzeitig authentisch zu bleiben.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-333">
              Das Coaching erhöht Wirksamkeit im Handeln, Sichtbarkeit in der
              Organisation und Erfolg in der Zielerreichung. Denn die Rolle von
              Führungskräften ändert sich – sie werden nicht überflüssig, aber
              ihre Rollen und Aufgaben unterliegen in vielen Organisationen
              einem Wandel.
            </p>
          </div>
          <div data-id="element-334">
            <p className="mb-6 text-base leading-relaxed" data-id="element-335">
              Durch meine eigene Führungserfahrung in internationalen
              Organisationen verfüge ich über Wissen um Unternehmenspolitik,
              schwierige Führungssituationen, das Management von Stakeholdern
              und um ungeschriebene Spielregeln der Macht.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-336">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-337">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};